/// <reference path="../../../scripts/typings/Nema.Crew.Model.d.ts" />

import service = require("./breeze.entitymanager.service");
import base = require("./base.dataservice");

export function initialize(module: ng.IModule) {
    module.service(RequirementDataService.Id, RequirementDataService);

    RequirementDataService.$inject = ["entityManagerService", "breeze", "$log", "$q"];
}

export class RequirementDataService extends base.BaseDataService<Nema.Crew.Model.CompetenceRequirement> {

    constructor(entityManagerService: service.EntityManagerService, breeze, $log, $q: ng.IQService) {
        super(entityManagerService, breeze, $log, $q);
    }

    public static Id: string = "requirementDataService";

    public get EntityName(): string {
        return "CompetenceRequirement";
    }

    public get EntitiesName(): string {
        return "CompetenceRequirements";
    }

    public deleteRelatedEntities(entity: Nema.Crew.Model.CompetenceRequirement): Promise<void> {
        entity.CompetenceRequirementCompetenceTypes.forEach(entity => (<breeze.Entity><any>entity).entityAspect.entityState = this.breeze.EntityState.Deleted);
        entity.CompetenceRequirementRoleTypes.forEach(entity => (<breeze.Entity><any>entity).entityAspect.entityState = this.breeze.EntityState.Deleted);
        entity.CompetenceRequirementActivityTypes.forEach(entity => (<breeze.Entity><any>entity).entityAspect.entityState = this.breeze.EntityState.Deleted);
        var deleteRelations = this.entityManager.saveChanges();

        return <Promise<void>><any>deleteRelations;
    }

    public newRequirementCompetenceType(defaultCompetenceTypeId: number): Nema.Crew.Model.CompetenceRequirementCompetenceType {
        return <Nema.Crew.Model.CompetenceRequirementCompetenceType><any>this.entityManager.createEntity('CompetenceRequirementCompetenceType', <Nema.Crew.Model.CompetenceRequirementCompetenceType>{
            CompetenceTypeId: defaultCompetenceTypeId
        });
    }

    public newRequirementRoleType(defaultRoleTypeId: number): Nema.Crew.Model.CompetenceRequirementRoleType {
        return <Nema.Crew.Model.CompetenceRequirementRoleType><any>this.entityManager.createEntity('CompetenceRequirementRoleType', <Nema.Crew.Model.CompetenceRequirementRoleType>{
            RoleTypeId: defaultRoleTypeId
        });
    }

    public newRequirementActivityType(defaultActivityTypeId: number): Nema.Crew.Model.CompetenceRequirementActivityType {
        return <Nema.Crew.Model.CompetenceRequirementActivityType><any>this.entityManager.createEntity('CompetenceRequirementActivityType', <Nema.Crew.Model.CompetenceRequirementActivityType>{
            ActivityTypeId: defaultActivityTypeId
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/requirements.dataservice.ts